import { IProgramSet } from '../../../types/interfaces/program-set';
import { ITrainingSet } from '../../../types/interfaces/training-set';

export enum SetOptionTableMode {
  training = 'training',
  program = 'program',
}

export const SetOptionTableFieldName = {
  [SetOptionTableMode.training]: {
    setItemsFieldName: 'trainingSetItems',
    optionsFieldName: 'trainingSetItemOptions',
    optionFieldName: 'programValue',
    optionFieldName2: 'programValue2',
  },
  [SetOptionTableMode.program]: {
    setItemsFieldName: 'programSetItems',
    optionsFieldName: 'programSetItemOptions',
    optionFieldName: 'value',
    optionFieldName2: 'value2',
  },
};

export interface ISetOptionTableProps {
  set: ITrainingSet | IProgramSet;
  mode: SetOptionTableMode;
  valueProperty?: 'value' | 'programValue';
  showSetsColumn?: boolean;
  showRestColumn?: boolean;
  canSaveSet?: boolean;
  onSaveSet?: (title: string) => Promise<any>;
}
